export const fieldLabels = {
  type: 'DCQ Type',
  action: 'Action',
  initial_value: 'Initial Value',
  new_value: 'New Value',
  requested_change: 'Requested Change',
  reason_for_change: 'Reason for Change',
};

export function requiredError(field) {
  return `${fieldLabels[field] || field} is required.`;
}